import { Link } from 'react-router-dom';
import { movieCategories, siteInfo } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-50">秋霞影院</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              海量高清影视资源，免费在线观看。追剧看片，尽在秋霞影院。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-background-300 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-foreground-400 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-background-300 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-foreground-400 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-background-300 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-foreground-400 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-100 mb-4">影视分类</h4>
            <ul className="space-y-2">
              {movieCategories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-sm text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-100 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">免责声明</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">隐私政策</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-100 mb-4">关于本站</h4>
            <ul className="space-y-2 text-sm text-foreground-500">
              <li>成立时间：{siteInfo.founded}年</li>
              <li>影片资源：{siteInfo.totalMovies}</li>
              <li>日均访问：{siteInfo.dailyVisitors}</li>
              <li>
                联系邮箱：
                <a href={`mailto:${siteInfo.email}`} className="text-accent-400 hover:text-accent-300 transition-colors cursor-pointer">
                  {siteInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 秋霞影院 QiuxiaYY.com - 本站内容仅供学习交流，请支持正版
          </p>
          <p className="text-xs text-foreground-600">
            友情链接：
            <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer ml-1" rel="nofollow">影视导航</a>
            <span className="mx-1">|</span>
            <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer" rel="nofollow">电影资讯</a>
          </p>
        </div>
      </div>
    </footer>
  );
}